import { OrderInlineInput } from './OrderInlineInput'
import { OrderAddressInlineInput } from '@ztechapps/order.webui'
import React from 'react'
import { ShowIf } from '@ztechapps/webui.util'
import { orderUpdateOrderAddressQuery } from '@ztechapps/order.common'
import type { Order } from '@ztechapps/common.contract'

type BillingDetailsProps = {
  companyName: string
  customerName: string
  customerId: string
  canEdit: boolean
  orderId: string
  addressType: 'billing' | 'shipping'
  label?: string
  initialValues?: Partial<Order>
}
export const BillingDetails = ({
  companyName,
  customerName,
  customerId,
  canEdit,
  orderId,
  addressType,
  label,
  initialValues,
}: BillingDetailsProps) => {
  return (
    <>
      <ShowIf condition={false}>
        <h5>{companyName}</h5>
      </ShowIf>

      <ShowIf condition={false}>
        <h6>{customerName}</h6>
      </ShowIf>
      <OrderInlineInput
        parentInputComponent={OrderAddressInlineInput}
        mutationConfig={{ query: orderUpdateOrderAddressQuery }}
        canEdit={canEdit}
        name={`${addressType}Address`}
        label={label}
        initialValues={initialValues}
        inputProps={{
          addressType,
          orderId: orderId,
          customerId: customerId,
          hideAiWand: true,
        }}
      />
    </>
  )
}
